import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { Collection } from './collection'
import {
  sanitizedCollectionsSelector,
  ISanitizedCollections
} from '../../selectors/collections'
import { isTabSupportedCollection } from './collectionTypes'

export interface ICollectionProps {
  collections: ISanitizedCollections
  useBtfTab: boolean
}

const ConnectedCollections = ({ collections, useBtfTab }: ICollectionProps) => {
  return (
    <>
      {collections.map((col, idx) => {
        if (col === null) return null
        if (useBtfTab) {
          return !isTabSupportedCollection(col.collectionType) && <Collection {...col} key={`collection-${col.index}-${idx}`} />
        } else {
          return <Collection {...col} key={`collection-${col.index}-${idx}`} />
        }
      })}
    </>
  )
}

const mapStateToProps = (state: IDetailPageState): ICollectionProps => ({
  collections: sanitizedCollectionsSelector(state),
  useBtfTab: state.features.useBtfTab
})

export const Collections = connect(mapStateToProps)(ConnectedCollections)
